import { Button } from "antd";
import { useAppSelector } from "../../../../app/store";
import EditButtonIcon from "../../../../assets/icons/EditButtonIcon";
import InfoItem from "../../../../components/common/InfoItem";
import Loader from "../../../../components/ui/Loader";
import { useGetEmployeeDetailsQuery } from "../../../../features/employee/employeeApi";
import useModal from "../../../../hooks/useModal";
import EditPersonalProfileModal from "../edit/EditPersonalProfileModal";

export type ProfileUpdateData = {
  id?: number;
  photo?: string | null;
};

export default function PersonalProfile() {
  const { open, handleOpen, handleClose } = useModal();
  const { authInfo } = useAppSelector((state) => state.auth);
  const { data, isLoading } = useGetEmployeeDetailsQuery(
    authInfo?.id?.toString() || "",
    {
      skip: !authInfo?.id,
    }
  );

  const profile = data?.data?.employee;

  return (
    <>
      {open.type === "UPDATE" && (
        <EditPersonalProfileModal open={open.open} handleClose={handleClose} />
      )}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-body text-xl font-semibold leading-normal">
          Profile
        </h2>
        <Button
          className="outline-button-primary !min-w-[151px] h-10"
          icon={<EditButtonIcon />}
          onClick={() =>
            handleOpen({
              type: "UPDATE",
            })
          }
        >
          Edit
        </Button>
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <ul>
          <InfoItem title="Name">{profile?.member?.profile?.name}</InfoItem>
          <InfoItem title="Mobile Number">{profile?.mobile}</InfoItem>
          <InfoItem title="Email">{profile?.member?.profile?.email}</InfoItem>
        </ul>
      )}
    </>
  );
}
